'use client';

import type { MutableRefObject } from 'react';
import { useEffect } from 'react';

export const useOnClickOutside = <T extends HTMLElement | null>(
    ref: MutableRefObject<T> | MutableRefObject<T>[],
    handler: (event?: Event) => void
): void => {
    useEffect(() => {
        const listener = (event: Event) => {
            const handleClickOutside = (singleRef: MutableRefObject<T>) => {
                const baseRef = singleRef.current;

                return !baseRef || (event.target instanceof Node && baseRef.contains(event.target));
            };

            const shouldSkip = Array.isArray(ref)
                ? ref.some(singleRef => handleClickOutside(singleRef))
                : handleClickOutside(ref);

            if (!shouldSkip) {
                handler(event);
            }
        };

        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);

        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]);
};
